import { CYCLE_STEPS, type CycleStep } from "@domain/steps.js";

const PREFIX = "/app/";

/** Parse only the seven product routes; an unknown path never becomes state. */
export const stepFromPath = (pathname: string): CycleStep | undefined => {
  if (!pathname.startsWith(PREFIX)) return undefined;
  const candidate = pathname.slice(PREFIX.length);
  return CYCLE_STEPS.find((step) => step === candidate);
};

export const pathForStep = (step: CycleStep): string => `${PREFIX}${step}`;
